<form [formGroup]="form" class="income_range">
  <div class="row justify-content-center">
    <div class="table-responsive">
      <table class="table quote-table">
        <thead>
          <th>
            {{ data.qualification.qualification_name | uppercase }} ({{
              getbuttonText()
            }})
          </th>
          <th>
            # OF
            {{ data.clickBalance ? 'CLICKS' : 'COMPLETES' }} (0 to
            {{ data.complete || '' }})
          </th>
          <th class="min-max-width">
            <span>MIN</span>
          </th>
          <th class="min-max-width">
            <span class="">MAX</span>
          </th>
          <th>&nbsp;</th>
        </thead>
        <tbody
          *ngIf="
            valueExist(data.qualification.data[0].minValue) &&
            valueExist(data.qualification.data[0].maxValue)
          "
          formArrayName="quotas"
          class="add-input-fields"
        >
          <tr
            *ngFor="let quotaForm of quotas.controls; let i = index"
            [ngClass]="{ 'row-disabled': disableLastRow && i === 0 }"
            [formGroupName]="i"
          >
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mt-4"
                formControlName="min"
                [minlength]="data.qualification.data[0].maxlengthMin"
                [maxlength]="data.qualification.data[0].maxlengthMax"
                [attr.readonly]="i > 0 || disableLastRow ? true : null"
                (change)="validateRange($event, i)"
                psUiInputRestriction="[0-9]"
              />
              <span class="px-2">to</span>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mt-4"
                formControlName="max"
                [minlength]="data.qualification.data[0].maxlengthMin"
                [maxlength]="data.qualification.data[0].maxlengthMax"
                [attr.readonly]="i > 0 || disableLastRow ? true : null"
                (blur)="validateRange($event, i)"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mt-4"
                formControlName="number"
                (keyup)="numberChange($event, i)"
                psUiInputRestriction="[0-9]"
              />
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mx-2 mt-4"
                maxlength="3"
                (keyup)="percentageChange($event, i)"
                formControlName="percentage"
                psUiInputRestriction="[0-9]"
              />
              <span>%</span>
            </td>
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mt-4"
                formControlName="minimum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control border-0 border-bottom text-center rounded-0 mt-4"
                maxlength="3"
                formControlName="maximum"
                [attr.readonly]="true"
                psUiInputRestriction="[0-9]"
              />
            </td>
            <td>
              <a *ngIf="i === 0" class="link-primary" (click)="addQuotaRow()">
                <i class="fa fa-plus"></i> Click to Add
              </a>
              <a *ngIf="i > 0" class="link-primary" (click)="deleteQuotaRow(i)">
                <i class="fa fa-times"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</form>
